import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { SapTableLinkedService } from '../linkedservice/sap-table.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapTable.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapTable_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapTable_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapTableLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
